import { ImageFallback, Text, Tooltip, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { messageError } from '../../utils';

interface EquityProductDisplayProps {
  src: string | null;
  productName: string | null;
  symbol: string | null;
}

export const EquityProductDisplay: React.FC<Partial<EquityProductDisplayProps>> = ({
  productName,
  symbol,
  src,
}) => {
  return (
    <HStack alignItems={'center'} justifyContent={'center'} space={Spacing['inline.nano']}>
      <ImageFallback
        src={src || ''}
        alt="logo-equity-product"
        width={Spacing['stack.lg']}
        height={Spacing['inline.md']}
        testID="product-img"
        resizeMode="cover"
        resizeMethod="scale"
        borderRadius={BoxRadius.sm}
      />
      <Tooltip testID="qa" label={productName || messageError}>
        <VStack maxW={{ base: 'full', lg: '90px' }}>
          <Text variant="semibold" color={'neutral.darkest'} noOfLines={1}>
            {productName || messageError}
          </Text>
          <Text variant="regular" color={'neutral.darkest'} noOfLines={1}>
            {symbol || messageError}
          </Text>
        </VStack>
      </Tooltip>
    </HStack>
  );
};
